import request from "./../utils/request";
import log2 from "../utils/log2";

const log = log2("WEBPHONE_UNIFIED_API");

export const WEBPHONE_UNIFIED_API = {
    /**
     * Tüm aktif webphone sağlayıcılarından visitor CDR'larını getirir
     * @param {string} visitorId - Visitor ID
     * @returns {Promise<object>} - Unified CDR kayıtları
     */
    getVisitorCDRList: (visitorId) => {
        log("getVisitorCDRList", { visitorId });
        return request
            .post(
                `/webphone/visitor-cdr/${visitorId}`,
                {},
                {
                    timeout: 60000,
                }
            )
            .then((response) => response.data);
    },
};